import './connection-applied-info-cell.scss';
import { ConnectionModel } from '../../connection.model';
import AttIon from '@svg/att-icon-black.svg?react';

const AttUser = () => <><AttIon/><span className="att-user">AT&T</span></>;

const ConnectionAppliedInfoCell: React.FC<{ connection: ConnectionModel }> = ({ connection }) => {

    return (
        <div className={'connection-applied-info-cell'}>
            {connection.formattedPolicyApplyDate}
            <span className="separator-dot" />
            {connection.policyApplyUser?.endsWith('att.com') || connection.policyApplyUser?.toUpperCase() === 'SYSTEM' ? <AttUser /> : connection.policyApplyUser}
        </div>
    );
};

export default ConnectionAppliedInfoCell;